(window as any).__AMAZEMOVE_CONFIG = {
  env: process.env.AMAZEMOVE_ENV,
  apiLocation: process.env.API_LOCATION,
};
export const IS_DEV = process.env.AMAZEMOVE_ENV === "development";
export const IS_TEST = process.env.AMAZEMOVE_ENV === "test";
export const IS_PROD = process.env.AMAZEMOVE_ENV === "production";
// export const WS_PATH = `ws://192.168.110.217:8207/websocket/user`;
export const FILE_UPLOAD_CODE = IS_DEV || IS_TEST || process.env.API_LOCATION == "hk" ? "aliyun" : "amazon";

export const GLOBAL_KEYS = {
  USER_INFO: "_uis",
  USER_TOKEN: "token",
  TOKEN_EXPIRE: "_te",
  PLAT_THEME: "_pt",
  API_LOCATION: "_al",
};

const getCompanySettings = () => {
  switch (process.env.API_LOCATION) {
    case "oem":
      return {
        title: "Carbinox MAX",
        slogan: "DURABILITY AND RELIABILITY, BEYOND REALITY!",
        copyright: "OHMIUX LLC",
        // logo: require("@/public/carbinox-logo.png"),
      };
    case "cn":
      return {
        title: "猎动",
        slogan: "以科技驱动体验的专业运动品牌",
        copyright: "猎动科技",
        // logo: require("@/assets/logo-cn.svg"),
      };
    default:
      return {
        title: "APEXMOVE",
        slogan: "WATCH YOU WANT!",
        copyright: "KOSPET",
        // logo: require("@/assets/logo-name.svg"),
      };
  }
};

export const COMPANY_SETTINGS = getCompanySettings();